import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { cookieKeys } from "../../services/Cookies";

import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Avatar from "@material-ui/core/Avatar";
import { BreadcrumbPage } from "../../shared";
import { CommonCss } from "../../services/CommonCss";
import { getCookie } from "../../services/Cookies";
import clsx from "clsx";
import ContractDetails from "../contracts/ContractDetails";
import Moment from "react-moment";
import { FormFormat } from "./FormFormat";
import { passwordObj } from "./FormFormat";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import axios from "axios";


const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    padding: "20px 20px 30px",
    boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
    borderRadius: 8,
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  active: {
    backgroundColor: "#F5F5F4",
  },
  table: {
    minWidth: 650,
  },
  root: {
    display: "flex",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: "0 60px",
    minHeight: "86vh",
    marginTop: "0 !important",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "#ff4717",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  w50: {
    width: "50%",
  },
  w30: {
    width: "30%",
  },
  w70: {
    width: "70%",
  },
  txtInput: {
    "& input": {
      padding: "8px",
      fontWeight: 600,
    },
    "& fieldset": {
      borderRadius: 0,
    },
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    background: "#fff !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
}));

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const tableClasses = useRowStyles();
  const classes = useStyles();

  return (
    <React.Fragment>
      <TableRow
        className={clsx(
          tableClasses.root,
          open ? classes.active : classes.inactive
        )}
      >
        {/*<TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
       </TableCell>*/}
        {/*<TableCell component="th" scope="row">
          {row.customerName}
        </TableCell>*/}
        <TableCell align="center">
          {row.axContractId}
        </TableCell>
        <TableCell align="center">
          {" "}
          {row.billingStartDate == null ? "" : <Moment format="DD MMMM YYYY">{row.billingStartDate}</Moment>}-{" "}
          {row.bIllingEndDate == null ? "" : <Moment format="DD MMMM YYYY">{row.bIllingEndDate}</Moment>}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              {/* <Typography variant="h6" gutterBottom component="div">
                {row.contractNumber}
              </Typography> */}
              <ContractDetails row={row} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    contractName: PropTypes.string.isRequired,
    contractDate: PropTypes.string.isRequired,
  }).isRequired,
};

const rows = [
  /* {
    contractName: "CTR-003351-0001",
    contractDate: "01 Jan 2015- 31 Dec 2020",
  },
  {
    contractName: "CTR-003351-0001",
    contractDate: "01 Jan 2015- 31 Dec 2020",
  },
  {
    contractName: "CTR-003351-0001",
    contractDate: "01 Jan 2015- 31 Dec 2020",
  },
  {
    contractName: "CTR-003351-0001",
    contractDate: "01 Jan 2015- 31 Dec 2020",
  }, */
];


function FormDetails(props) {
  const { row, getProfilepic } = props;
  const [open, setOpen] = React.useState(false);
  const tableClasses = useRowStyles();
  const classes = useStyles();
  const classesCommon = CommonCss();
  const [formObj, setFormObj] = useState(FormFormat);
  const dispatch = useDispatch();
  const [openBunkerAlerts, setOpenBunkerAlerts] = useState();
  const [profilePic, setProfilePic] = useState(null);
  const [passwordFormObj, setPasswordFormObj] = useState(passwordObj);


  useEffect(() => {
    debugger
    loadAPI();
  }, []);
  const loadAPI = async () => {
    await getAccountDetails();
  }
  const getAccountDetails = async () => {
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Account/Settings`;
    await getRequest(url)
      .then((res) => {
        ////console.log(res);
        dispatch({ type: LOADING, payload: false });
        setFormObj(res.data[0]);
        onDownloadProfilePic(res.data[0].picturepath);
      })
      .catch((error) => {
        setFormObj(formObj);
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const onDownloadProfilePic = (data, type = "onload") => {
    ////console.log(formObj.picturepath)
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Account/DownloadProfilePic`;
    let filedata = JSON.stringify({ fileName: data });
    ////console.log(formObj.picturepath );
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: " image/jpeg,image/png,image/gif"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        ////console.log(response);
        if (response.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "image/jpeg,image/png,image/gif" });
          //Build a URL from the file
          ////console.log(file)
          const fileURL = URL.createObjectURL(file);
          ////console.log(fileURL);
          const userData = {
            profileImgPath: fileURL
          }
          cookieKeys(userData, 30 * 60);
          getProfilepic(fileURL);
          if (type == "click") {
            window.open(fileURL, '_blank');
          }
          // var element = document.createElement("a");
          // element.href = URL.createObjectURL(file);
          // element.download = "image.jpg";
          // element.click();
          // var a = document.createElement('A');
          // a.href = fileURL;
          // a.download = fileURL.substr(fileURL.lastIndexOf('/') + 1);
          // document.body.appendChild(a);
          // a.click();
          // document.body.removeChild(a);
          // download = "fileName";
          // setOpenBunkerAlerts(fileURL);
        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
      });
  };
  const uploadProfileImage = async (data) => {
    // Create an object of formData
    const formData = new FormData();
    // Update the formData object
    formData.append("file", data);
    // Details of the uploaded file
    ////console.log(formData);
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Account/UploadProfilePic`;
    await postRequest(url, formData)
      .then((res) => {
        dispatch({ type: LOADING, payload: false });
        getAccountDetails();

        // ////console.log(res);
        // ToastSuccess("img Uploaded");
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const updateAccountDetails = async (data) => {
    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Account/UpdateSettings`;
    ////console.log(data);
    await putRequest(url, data)
      .then((res) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(res);
        // setFormObj( {formObj.profilePic : res})
        // ToastSuccess("img Uploaded");
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  const onSubmitProfile = (event) => {
    ////console.log(event.target.files[0],"img");
    var file = event.target.files[0];
    setProfilePic(file);
    var reader = new FileReader();
    reader.onloadend = function () {
      // ////console.log('Encoded Base 64 File String:', reader.result);
      /******************* for Binary ***********************/
      var data = (reader.result).split(',')[1];
      var binaryBlob = atob(data);
      ////console.log('Encoded Binary File String:', binaryBlob);
      uploadProfileImage(file);
    }
    reader.readAsDataURL(file);
  }
  // ////console.log(profilePic);

  const onSubmitAccount = () => {
    ////console.log(formObj);
    updateAccountDetails(formObj);
  }

  const onChangeText = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
  };
  const changePass = () => {
    ////console.log(passwordFormObj,'test');
    if (!passwordFormObj.oldPassword) {
      ToastError("Old password is required");
    } else
      if (!passwordFormObj.newPassword) {
        ToastError("New password is required");
      } else
        if (!passwordFormObj.confirmPassword) {
          ToastError("Confirm password is required");
        } else
          if (passwordFormObj.newPassword == passwordFormObj.confirmPassword) {
            updatePasswordDetails(passwordFormObj);
          } else {
            ToastError("New password and Confirm password not matched");
          }

  }
  const onChangePwdText = (event) => {
    setPasswordFormObj({ ...passwordFormObj, [event.target.name]: event.target.value });
  }
  const updatePasswordDetails = async (dataObj) => {

    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Account/UpdatePassword`;
    ////console.log(dataObj);
    // await putRequest(url, dataObj,(response)=>{
    //   dispatch({ type: LOADING, payload: false });
    //   if(response.status!="200")
    //   {
    //     let errMsg=[];
    //     response.data.forEach((msg)=>{
    //       errMsg.push(msg.description);
    //     });
    //     ToastError(errMsg.join("<br>"));
    //   }
    //   else
    //   {
    //     setPasswordFormObj({...passwordFormObj, newPassword:"", oldPassword:"", confirmPassword:""})
    //     ToastSuccess("Password Updated Succesfully");
    //   }
    //   ////console.log(response);
    // })
    await putRequest(url, dataObj).then((res) => {
      dispatch({ type: LOADING, payload: false });
      // ;
      ToastSuccess("Password updated");
      setPasswordFormObj({ ...passwordFormObj, newPassword: "", oldPassword: "", confirmPassword: "" })
      ////console.log(res);
    })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        if (error.response.data) {
          if (error.response.data.length) {
            let errMsg = [];
            error.response.data.forEach((msg) => {
              errMsg.push(msg.description);
            });
            ToastError(errMsg.join("<br>"));
          } else {
            ToastError(error.response.data.message);
          }
        }
        ////console.log(error);
      });
  }
  ////console.log(formObj,"formObj");
  ////console.log(passwordFormObj,"formObj");

  return (
    <React.Fragment>
      <TableRow
        className={clsx(
          tableClasses.root
          // open ? classes.active : classes.inactive
        )}
      >
        <TableCell className={classes.w50}>
          <Box

            aria-label="expand row"
            size="small"
            className={classesCommon.cursorPointer}
            onClick={() => setOpen(!open)}
          >
            <Box display="flex" alignItems="center">
              <Box component="IconButton" fontSize="0px">
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </Box>
              <Box component="span" pl={2}>
                {row.type == "accountDetails" ? "Account Details" : ""}
                {row.type == "passwordDetails" ? "Password Details" : ""}
              </Box>
            </Box>
          </Box>
        </TableCell>
        <TableCell className={classes.w50}></TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={2}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {row.type == "accountDetails" ? (
              <Box>
                <Box display="flex">
                  <Box width={0.5} pl={17} pr={6}>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.25}>
                        {"First Name"}
                      </Box>
                      <Box component="span" width={0.55}>
                        <BootstrapInput
                          value={formObj.firstname}
                          name="firstname"
                          onChange={onChangeText}
                        />
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.25}>
                        {"Email"}
                      </Box>
                      <Box component="span" width={0.55}>
                        <BootstrapInput
                          value={formObj.email}
                          name="email"
                          onChange={onChangeText}
                        />
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.25}>
                        {"Profile Picture"}
                      </Box>
                      <Box component="span" width={0.55}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          type="file"
                          name="picturepath"
                          // value={formObj.picturepath}
                          onChange={onSubmitProfile}
                          className={classes.txtInput}
                        // onChange={(e) => setPass(e.target.value)}
                        />
                      </Box>
                      <Box component="span" width={0.2} textAlign="right">
                        {/* <Button onClick={onSubmitProfile} className={classes.btnStyle1}>Browse</Button> */}
                        {/* <input type="file" name="profile" onChange={onSubmitProfile} /> */}
                      </Box>
                    </Box>
                    {
                      formObj.picturepath ?
                        <Box display="flex" alignItems="center" pb={1}>
                          <Box component="span" fontWeight="600" width={0.25}>
                          </Box>
                          <Box component="span" width={0.55}>
                            <a onClick={() => { onDownloadProfilePic(formObj.picturepath, "click") }}
                              style={{ cursor: "pointer" }}
                            // href={formObj.picturepath}

                            // download ={formObj.picturepath}
                            >
                              {formObj.picturepath}</a>
                          </Box>
                        </Box> : ""
                    }
                  </Box>
                  <Box width={0.382}>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.25}>
                        {"Last Name"}
                      </Box>
                      <Box component="span" width={0.55}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          className={classes.txtInput}
                          value={formObj.lastname}
                          name="lastname"
                          onChange={onChangeText}
                        />
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.25}>
                        {"Designation"}
                      </Box>
                      <Box component="span" width={0.55}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          name="email"
                          className={classes.txtInput}
                          value={formObj.designation}
                          name="designation"
                          onChange={onChangeText}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box component="flex">
                  <Box width={1} pb={4} textAlign="center">
                    <Button className={classes.btnStyle2} onClick={onSubmitAccount} >Save</Button>
                  </Box>
                </Box>
              </Box>
            ) : (
              ""
            )}
            {row.type == "passwordDetails" ? (
              <Box>
                <Box display="flex">
                  <Box width={0.5} pl={17} pr={6}>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.4}>
                        {"Current Password"}
                      </Box>
                      <Box component="span" width={0.5}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          type="password"
                          required
                          fullWidth
                          value={passwordFormObj.oldPassword}
                          name="oldPassword"
                          onChange={(e) => { onChangePwdText(e) }}
                          className={classes.txtInput}
                        // onChange={(e) => setPass(e.target.value)}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box width={0.382}>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.4}>
                        {"New Password"}
                      </Box>
                      <Box component="span" width={0.5}>
                        <TextField
                          variant="outlined"
                          margin="dense"
                          type="password"
                          required
                          fullWidth
                          value={passwordFormObj.newPassword}
                          name="newPassword"
                          onChange={onChangePwdText}
                          className={classes.txtInput}
                        // onChange={(e) => setPass(e.target.value)}
                        />
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" pb={1}>
                      <Box component="span" fontWeight="600" width={0.4}>
                        {"Confirm New Password"}
                      </Box>
                      <Box component="span" width={0.5}>
                        <TextField
                          type="password"
                          variant="outlined"
                          margin="dense"
                          required
                          fullWidth
                          value={passwordFormObj.confirmPassword}
                          name="confirmPassword"
                          onChange={onChangePwdText}
                          className={classes.txtInput}
                        // onChange={(e) => setPass(e.target.value)}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box component="flex">
                  <Box width={1} pb={4} textAlign="center">
                    <Button className={classes.btnStyle2} onClick={changePass} >
                      Change Password
                    </Button>
                  </Box>
                </Box>
              </Box>
            ) : (
              ""
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const accountDetailsForm = [
  { type: "accountDetails" },
  { type: "passwordDetails" },
];

export default function Account() {
  const classes = useStyles();
  const BreadcrumbList = [{ name: "Account", url: "" }];
  const [contractDetails, setContractDetails] = React.useState([]);
  const dispatch = useDispatch();
  const [uploadImg, setUploadImg] = React.useState([]);

  useEffect(() => {
    loadAPI();
  }, []);
  const loadAPI = async () => {
    await getContracts({ customerKeys: getCookie("clientId") });
  }

  const getContracts = async (data) => {
    debugger
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Account/Contracts`;
    await getRequest(url)
      .then((res) => {
        ////console.log(res);
        dispatch({ type: LOADING, payload: false });
        setContractDetails(res.data);
      })
      .catch((error) => {
        setContractDetails([]);
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  };
  const getProfilepic = (data) => {
    ////console.log(data);
    setUploadImg(data);
  }

  return (
    <div>
      <Box component="main" className={classes.content + " rightbar accountmain"}>
        <Box pb={3} pt={0} display="dlock">
          <BreadcrumbPage rows={BreadcrumbList} />
        </Box>
        <Box className={classes.boxLayout}>
          <Box display="flex" alignItems="center" px={3} pt={1} pb={5}>
            <Avatar
              alt="user logo"
              className={classes.large}
              // src={
              //   process.env.REACT_APP_CUSTOMER_PORTAL_URL +
              //   "assets/user_imgs/" +
              //   getCookie("profileImg")
              // }
              src={
                uploadImg != "" ? uploadImg : process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                  "assets/user_imgs/default_img.png"
              }
            // src={uploadImg}
            />
            <Box px={3}>
              <Box component="p" style={{ fontSize: 20 }} pb={1} m={0}>
                Hi
              </Box>
              <Box component="h2" pb={1} m={0}>
                {getCookie("name")}
              </Box>
              <Box component="p" style={{ fontSize: 20 }} pb={1} m={0}>
                {getCookie("type")}
              </Box>
              <Box component="p" style={{ color: "#FF4717" }} m={0}>
                {contractDetails.length + ' Contracts'}
              </Box>
            </Box>
          </Box>
          <Box className={classes.root} pb={0}>
            <TableContainer component={Paper} className={classes.tableLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow className={classes.w50}>
                    <StyledTableCell className="bl-bg">
                      <Box pl={15}> Contract Details</Box>
                    </StyledTableCell>
                    <StyledTableCell className={classes.w50 + " bl-bg"}></StyledTableCell>
                  </TableRow>

                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <Row key={row.customerName} row={row} />
                  ))}

                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box class Name={classes.root}>
            <TableContainer
              component={Paper}
              className={clsx(classes.TableTheme)}
            >
              <Table
                aria-label="collapsible table"
                className={classes.tableLayout}
              >
                <TableBody>
                  {contractDetails.length
                    ? contractDetails.map((row) => (
                      <Row key={row.contractKey} row={row} />
                    ))
                    : (<TableCell colSpan="4">
                      <Box textAlign="center" m={2}>No Record Found</Box>
                    </TableCell>)}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box className={classes.root} pb={0}>
            <TableContainer component={Paper} className={classes.tableLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.w50 + " bl-bg"}>
                      <Box pl={15}> Account Settings</Box>
                    </StyledTableCell>
                    <StyledTableCell className={classes.w50 + " bl-bg"}></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {accountDetailsForm.map((row) => (
                    <FormDetails key={row.type} row={row} getProfilepic={getProfilepic} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </div>
  );
}